export default __webpack_public_path__ + "img/mobilite-homepage.c130b84a.svg";